import {
  Text,
  Box,
  Stack,
  useMediaQuery,
  StackProps,
  TextProps,
  ChakraStyleProps,
} from "@chakra-ui/react";
import React, { FC, forwardRef, useState } from "react";
import { ReactComponent as BellOrange } from "../../assets/bellOrange.svg";
import { AnimateSharedLayout, motion } from "framer-motion";
import { ReactComponent as BellBlue } from "../../assets/bellBlue.svg";

const MotionStack = motion(Stack);

const ButtonStyling: {
  root: Partial<
    ChakraStyleProps &
      Pick<StackProps, "direction" | "spacing" | "align" | "justify">
  >;
  text: Partial<TextProps>;
} = {
  root: {
    backgroundColor: "#ffffff",
    borderRadius: "50px",
    boxShadow: "0px 5px 32px -7px rgba(126, 136, 151, 0.8)",
    direction: "row",
    padding: "12px 24px",
    position: "relative",
    cursor: "pointer",
    spacing: "4",
    align: "center",
    justify: "flex-start",
  },
  text: {
    color: "#F9A825",
    flexGrow: 1,
  },
};

type NotificationTargetProps = {
  onClick: () => void;
};

// Used specifically for desktops
export const NotificationFloater = forwardRef<
  HTMLDivElement,
  NotificationTargetProps
>((props, ref) => {
  const { onClick } = props;
  const [isLargerThan900] = useMediaQuery("(min-width: 900px)");
  const [text, setText] = useState("Nuevos Grupos");
  return (
    <AnimateSharedLayout>
      <MotionStack
        id="subscribePlatformPopoverTrigger"
        ref={ref}
        {...ButtonStyling.root}
        onClick={onClick}
        onMouseEnter={() => setText("Notificame cuando hayan Nuevos Grupos")}
        onMouseLeave={() => setText("Nuevos Grupos")}
        layout
        transition={{ duration: 0.25, type: "spring" }}
      >
        <Box width="20px !important">
          <BellOrange />
        </Box>
        <Text
          {...ButtonStyling.text}
          textStyle={isLargerThan900 ? "button" : "buttonMobile"}
        >
          {text}
        </Text>
      </MotionStack>
    </AnimateSharedLayout>
  );
});

// Used only in desktop view
export const NotificationButton: FC<NotificationTargetProps> = (props) => {
  const { onClick } = props;
  const [isLargerThan900] = useMediaQuery("(min-width: 900px)");
  return (
    <Stack {...ButtonStyling.root} onClick={onClick}>
      <Box width="20px !important">
        <BellOrange />
      </Box>
      <Text
        {...ButtonStyling.text}
        textStyle={isLargerThan900 ? "button" : "buttonMobile"}
      >
        Notificame cuando hayan sitios
      </Text>
    </Stack>
  );
};

export const NotificationIcon: FC<NotificationTargetProps> = (props) => {
  const { onClick } = props;
  return (
    <Box onClick={onClick}>
      <BellBlue />
    </Box>
  );
};
